import { zodResolver } from "@hookform/resolvers/zod";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import { DefaultValues, useForm } from "react-hook-form";
import { z } from "zod";

import { buildDetectorGroupsUrl } from "api/services/useDetectorGroups";
import { DetectorGroup } from "components/createDetector/CreateDetectorModal";
import { ListResponse } from "types/api";

const checkIfDetectorGroupNameIsAvailable = async (value: string): Promise<boolean> => {
  const url = buildDetectorGroupsUrl({ page_size: 1, name: value });
  const response = await fetch(url);

  const data = (await response.json()) as ListResponse<DetectorGroup>;
  return data.count === 0;
};

const checkNameDebounced = AwesomeDebouncePromise(checkIfDetectorGroupNameIsAvailable, 500);

const detectorGroupCreationSchema = z.object({
  name: z
    .string()
    .min(1, { message: "Group name is required" })
    .max(100, { message: "Group name is too long (max 100 characters)." })
    .refine(checkNameDebounced, { message: "Name already exists. Please try a different one" }),
});

type DetectorGroupFormData = z.infer<typeof detectorGroupCreationSchema>;

type UseDetectorGroupFormParams = {
  defaultValues?: DefaultValues<DetectorGroupFormData>;
};

export function useDetectorGroupForm({ defaultValues }: UseDetectorGroupFormParams = {}) {
  return useForm<DetectorGroupFormData>({
    resolver: zodResolver(detectorGroupCreationSchema),
    mode: "onChange",
    defaultValues: {
      name: defaultValues?.name ?? "",
    },
  });
}
